import { Typography } from '@material-ui/core'
import React from 'react'

export const DMLview = ({ procedureData }: { procedureData: any }) => {
    return (
        <div>
            <Typography variant="body1">
                Ambient temperature :{procedureData?.dml?.ambient_temperature ? `${procedureData.dml.ambient_temperature }°C` : "N/A"} 
            </Typography>
            <Typography variant="body1">
                Ambient humidity : {procedureData?.dml?.ambient_humidity ?`${ procedureData.dml.ambient_humidity } %RH`: "N/A"} 
            </Typography>
            <Typography variant="body1">
                Calibration Date : {procedureData?.dml?.equipment_calibration_date ? procedureData.dml.equipment_calibration_date.substring(0, 10) : "N/A"}
            </Typography>
            <Typography variant="body1">
                Installation method : {procedureData?.dml?.installation_method ? procedureData.dml.installation_method : "N/A"}
            </Typography>
            <Typography variant="body1">
                Mounting hardware : {procedureData?.dml?.mounting_hardware ? procedureData.dml.mounting_hardware : "N/A"}
            </Typography>
            <Typography variant="body1">
                Test pressure :{procedureData?.dml?.test_pressure ?`${procedureData.dml.test_pressure }Pa` : "N/A"} 
            </Typography>
            <Typography variant="body1">
                Number of test cycles/min :{procedureData?.dml?.no_of_test_cycle ? procedureData.dml.no_of_test_cycle : "N/A"}
            </Typography>
            <Typography variant="body1">
                Number of test cycles(total): {procedureData?.dml?.total_test_cycle ? procedureData.dml.total_test_cycle : "N/A"}
            </Typography>
            <Typography variant="body1">
                DUT circuit check normal : {procedureData?.dml?.dut_circuit_normal ? procedureData.dml.dut_circuit_normal : "N/A"}
            </Typography>

        </div>
    )
}


